import { render, staticRenderFns } from "./StaffAllocationPrint.vue?vue&type=template&id=536fff7d&scoped=true&"
import script from "./StaffAllocationPrint.vue?vue&type=script&lang=js&"
export * from "./StaffAllocationPrint.vue?vue&type=script&lang=js&"
import style0 from "./StaffAllocationPrint.vue?vue&type=style&index=0&id=536fff7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536fff7d",
  null
  
)

export default component.exports